import { Text } from "react-native-paper";
import type { LevelIconName } from "../../icon";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { LevelIcon } from "../LevelIcon";
import TooltipWrapper from "../TooltipWrapper";

type Props = {
	icon?: LevelIconName;
	label?: string;
	tooltip?: string;
	hideIcon?: boolean;
};

export const InfoChip = ({ icon, label, tooltip, hideIcon }: Props) => {
	const theme = useAppTheme();

	const chip = (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent="center"
			gap={4}
			paddingHorizontal={8}
			paddingVertical={6}
			borderRadius={theme.roundness}
			backgroundColor={theme.colors.secondaryContainer}
			flexShrink={1}
			minWidth={0}
		>
			{hideIcon || !icon ? null : (
				<LevelIcon
					name={icon}
					size={16}
					color={theme.colors.onSecondaryContainer}
				/>
			)}
			{label ? (
				<Text
					variant="labelMedium"
					numberOfLines={1}
					style={{
						color: theme.colors.onSecondaryContainer,
						flexShrink: 1,
						minWidth: 0,
					}}
				>
					{label}
				</Text>
			) : null}
		</Box>
	);

	return tooltip ? (
		<TooltipWrapper title={tooltip}>{chip}</TooltipWrapper>
	) : (
		chip
	);
};
